import React from 'react';
import { useLocation } from 'react-router-dom';
import { AppLoading, AppPdfPage, AppPdfWrapper } from '../';
import {
	OrderReceiptAddressInfo,
	OrderReceiptDetails,
	OrderReceiptHistory,
	OrderReceiptItems,
	OrderReceiptTotals,
} from './Receipt';
import {
	getQueryParams,
} from "../../services/UtilityService";
import OrderService from "../../services/OrderService";

const OrderPrintReceipt = () => {
	const location = useLocation();
    const params = getQueryParams(location.search);
    const details = OrderService.getOrderData(params);
	const shouldShowSecondPage = React.useMemo(() => details?.items?.length > 12, [details?.items]);

	const renderHistory = () => {
		return <OrderReceiptHistory order={details} />;
	};

	return (
		<AppPdfWrapper title={'Order View'}>
			<AppPdfPage>
				<img src={`/images/logos/ttg.svg`} alt='Logo' />
				{ !details &&  <AppLoading /> }
				<div className='flex mt-6'>
					<OrderReceiptAddressInfo
						label={'Ordered From'}
						company={'The Table Group'}
						info={
							'1211 Newell Ave, Suite 150 <br /> Walnut Creek, CA 94596 <br /> ph: 925.299.9700 <br /> fx: 925.299.9708 <br /> www.tablegroup.com'
						}
					/>

					<OrderReceiptAddressInfo
						label={'Billed To'}
						company={details?.billingAddress?.company}
						info={`${details?.billingAddress?.name} <br /> ${details?.billingAddress?.street} <br /> ${details?.billingAddress?.location} ${details?.billingAddress?.country} <br /> ${details?.billingAddress?.phone}`}
					/>
				</div>

				{details && <OrderReceiptDetails order={details} />}

				{details && <OrderReceiptItems order={details} /> }

				{details && <OrderReceiptTotals order={details} /> }

				{!shouldShowSecondPage && details && renderHistory()}
			</AppPdfPage>

			{shouldShowSecondPage && <AppPdfPage>{renderHistory()}</AppPdfPage>}
		</AppPdfWrapper>
	);
};

export default OrderPrintReceipt;